import type { IArticle } from "@/models/knowledge_base"
import { defineStore } from 'pinia';

import { Article } from '@/models/knowledge_base';
import articleService from '@/services/knowledge_base/article';

import type { IArticleState } from "./article.types"

export const useArticleStore = defineStore('article', {
  state: (): IArticleState => ({
    articles: []
  }),

  getters: {
    getArticles(state: IArticleState): IArticle[] {
      return state.articles.map((article) => new Article(article))
    }
  },

  actions: {
    async fetchArticles() {
      const articles = await articleService.fetchArticles()
      this.articles = articles
    }
  }
})
